import React from 'react'
import { ToastContainer } from 'react-toastify'
import CssBaseLine from '@material-ui/core/CssBaseline'
import { ThemeProvider } from '@material-ui/styles'
import { SnackbarProvider } from 'notistack'

import AuthWatcher from '../AuthWatcher'
import MainRouter from '../MainRouter'
import theme from '../../modules/ui/theme'
import RootStore from '../RootStore'
import GlobalStyle from '../GlobalStyle'

function App() {
    return (
        // <React.StrictMode>
        <ThemeProvider theme={theme}>
            <SnackbarProvider maxSnack={3}>
                <RootStore>
                    <AuthWatcher />
                    <CssBaseLine />
                    <GlobalStyle />
                    <ToastContainer autoClose={3000} />
                    <MainRouter />
                </RootStore>
            </SnackbarProvider>
        </ThemeProvider>
        // </React.StrictMode>
    )
}

export default App
